export default {
  name: 'PAGE_VIEW',
  path: ''
}



// WEBPACK FOOTER //
// ./src/analytics/Events/PageView.js